import {
    initMain
} from './vue/controllers/main';
import {
    header
} from './vue/controllers/header';
import {
    covidComparatorMixin,
    covidSearchMixin
} from './vue/mixins/covid';
import lazyload from './features/lazy-load';

lazyload();

initMain([covidComparatorMixin, covidSearchMixin], {
    CovidComparatorGraph: () => import('./vue/components/covid-comparator-graph/CovidComparatorGraph.vue'),
    CovidRadarGraph: () => import('./vue/components/covid-radar-graph/CovidRadarGraph.vue'),
}, []);
header();